import { render, staticRenderFns } from "./AddNewBanner.vue?vue&type=template&id=ed1153da&scoped=true&"
import script from "./AddNewBanner.vue?vue&type=script&lang=js&"
export * from "./AddNewBanner.vue?vue&type=script&lang=js&"
import style0 from "./AddNewBanner.vue?vue&type=style&index=0&id=ed1153da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1153da",
  null
  
)

export default component.exports